import { render, staticRenderFns } from "./AppUserMenu.vue?vue&type=template&id=4bb3c7a0&scoped=true&"
import script from "./AppUserMenu.vue?vue&type=script&lang=js&"
export * from "./AppUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppUserMenu.vue?vue&type=style&index=0&id=4bb3c7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3c7a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
